/**
 * Raise-Support-Ticket policy constants (story 101869). Kept inside the feature and
 * exported via the barrel (ADR-0009: constants at the narrowest shared scope).
 */

import type { TicketStatus, TicketTab } from './types';

/** Title accepts at least 1 char, hard-capped at 200 (AC §3). */
export const TITLE_MAX = 200;

/** Description must be MORE than 20 chars to enable Submit; hard-capped at 2000 (AC §4). */
export const DESC_MIN = 20;
export const DESC_MAX = 2000;

/** Up to 5 images, JPG/PNG only, 5 MB each (AC §5). */
export const MAX_IMAGES = 5;
export const MAX_IMAGE_MB = 5;
export const ACCEPTED_IMAGE_TYPES = 'image/jpeg,image/png';

/** A grower may hold at most 10 Open/Active tickets at once (AC §7). */
export const MAX_OPEN_TICKETS = 10;

/** Backend error codes the UI branches on (AC §7 limit, §8 duplicate). */
export const SUPPORT_ERROR_CODES = {
  openTicketLimit: 'OPEN_TICKET_LIMIT',
  duplicate: 'DUPLICATE_TICKET',
} as const;

/**
 * "Subscription Category" options (Figma field). The AC does not specify this field, so
 * it is informational and optional; the values follow the domain Bundle-Tier vocabulary
 * (CONTEXT.md) plus the device's own plan, surfaced by the modal.
 */
export const SUBSCRIPTION_CATEGORIES = ['Basic', 'Advance', 'Advance +'] as const;

/** Tickets load 20 per reveal-window (story 101970 §5). */
export const TICKETS_PAGE_SIZE = 20;

/** Composer message hard cap (no AC governs this — defined in the design spec). */
export const MESSAGE_MAX = 2000;

/** Sender prefix for a support message preview in the listing (Figma 2389-764730). */
export const SUPPORT_SENDER_LABEL = 'FieldPro';

/** Which ticket statuses belong to each tab (story 101970 §2). */
export const STATUS_BY_TAB = {
  active: ['open', 'active'],
  closed: ['closed', 'invalid'],
} as const satisfies Record<TicketTab, TicketStatus[]>;

/** The listing tab a ticket status belongs to. */
export function tabForStatus(status: TicketStatus): TicketTab {
  return status === 'closed' || status === 'invalid' ? 'closed' : 'active';
}
